import { FC } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { formatNumberWithComma } from '../../utils/number';

type ICampaignPrice = {
	campaignPrice: number;
};

const CampaignPrice: FC<ICampaignPrice> = ({ campaignPrice }) => {
	const { t } = useTranslation();

	const amount = formatNumberWithComma(campaignPrice);

	return (
		<Box className="mt-4 flex items-center justify-end gap-x-4">
			<Button size="large" variant="outlined" className="flex w-72 cursor-default justify-between hover:bg-transparent">
				<Typography>{t('campaign_total_price')}:</Typography>
				<Trans i18nKey="tooman_amount_label" values={{ amount }} components={[<Typography className="text-sm font-medium text-text-primary" />]} />
			</Button>
		</Box>
	);
};

export default CampaignPrice;
